<div class="editor">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
      [staticdata]="staticdata" [textContentClass]="class['viewers-news__content']" [textWrapperClass]="class['viewers-news__content']"
      (changeTextAlignConfig)="changeWidthHeight({width: class['viewers-news']['width']})">
    </app-text-format-config>

    <!-- Khoảng cách chữ -->
    <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
      [classLetterSpacing]="class['viewers-news__content']" (updateClass)="updateClass()">
    </app-letter-spacing-config>
    <!-- Khoảng cách dòng -->
    <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
      [classLineHeight]="class['viewers-news__content']" (updateClass)="updateClass()">
    </app-line-height-config>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline">
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config
                    [device]="device"
                    [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->
      
      <!-- CHỮ VÀ ĐỊNH DẠNG -->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <div class="editor-field-body">

            <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
            [staticdata]="staticdata" [textContentClass]="class['viewers-news__content']" [textWrapperClass]="class['viewers-news__content']"
            (changeTextAlignConfig)="changeWidthHeight({width: class['viewers-news']['width']})">
          </app-text-format-config>

          <!-- Khoảng cách chữ -->
          <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classLetterSpacing]="class['viewers-news__content']" (updateClass)="updateClass()">
          </app-letter-spacing-config>
          <!-- Khoảng cách dòng -->
          <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classLineHeight]="class['viewers-news__content']" (updateClass)="updateClass()">
          </app-line-height-config>
           
          </div>
        </div>
      </li>
      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-text-style-config
                [config]="config"
                [class]="class"
                [staticdata]="staticdata"
                [device]="device"
                [objectChoosing]="objectChoosing"
                [textContentClass]="class['viewers-news__content']"
                [textWrapperClass]="class['viewers-news__wrapper']"
                [filterConfig]="config['filter']"
                [isShape]="false"
        >
        </app-text-style-config>
      </li>
      <!-- BIỂU TƯỢNG -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-symbol-config
              [device]="device"
              [class]="class"
              [config]="config"
              [symbolClass]="class['viewers-news__wrapper']"
              [fontSizeIconClass]="class['viewers-news__icon-inner']"
              [symbolConfig]="config['icon']"
              [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </li>
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['user-name']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
  </div>
</div>